import React from 'react'
import { Typography } from '@mui/material'
import Card from '@mui/material/Card'
import { CardType } from './Ui'

const SingleCard = ({ card }: { card: CardType }) => {
  return (
    <Card
      className="mui-card"
      sx={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}
    >
      <Typography variant="titleMedium">{card.title}</Typography>
      <Typography variant="bodyMedium">{card.description}</Typography>
    </Card>
  )
}

export default SingleCard
